import { FetchResult } from 'apollo-link';
import { DataProxy } from 'apollo-cache';
import { DocumentNode } from 'graphql';

import { QueryGetUserSegmentsArgs, UserSegment } from 'api';

interface IReducer {
  cache: DataProxy;
  result: FetchResult;
  query: DocumentNode;
  variables: QueryGetUserSegmentsArgs;
}

interface IData {
  getUserSegments: UserSegment[];
}

export default (options: IReducer) => {
  const { cache, result, query, variables } = options;
  const { getUserSegments }: IData = cache.readQuery({
    query,
    variables,
  });

  if (!getUserSegments) {
    return;
  }

  const { createUserSegment } = result.data;
  getUserSegments.unshift(createUserSegment);

  cache.writeQuery({
    query,
    variables,
    data: { getUserSegments },
  });
};
